<template>
    <div class="card shadow">
        <div class="card-body" style="min-height: 475px">
            <div class="abc">
                <div class="image" :style="resolveStyle" @click="handleClick"></div>
            </div>

            <div class="cont">
                <h4 class="mt-2 text-wellis-gold title cursor-button" @click="handleClick"> {{item.title}}</h4>
                <p v-html="nl2br(item.lead)" v-if="!empty(item.lead)"></p>
                <p v-else>
                    {{$t('components.news.no-lead')}}
                </p>
            </div>

        </div>
        <div class="card-footer text-wellis-gold">
            <div class="float-left">{{item.author_name}}</div>
            <div class="float-right">{{item.created_at | formatDate}}</div>
        </div>
    </div>
</template>

<script>
import {empty, nl2br} from "@/helpers";

export default {
    name: "NewsCard",
    props: {
        item: Object
    },

    methods: {
        handleClick() {
            this.$router.push({
                name: 'app.news.view',
                params: {
                    slug: this.item.slug
                }
            });
        },

        empty(value) {
            return empty(value);
        }
    },

    computed: {
        resolveStyle() {
            return `background-image: url('${this.item.header_image_url}');`;
        },

        nl2br() {
            return value => nl2br(value);
        }
    }
}
</script>

<style scoped>

.cont {
    height: 260px;
    min-height: 260px;
    max-height: 260px;
}

.image {
    cursor: pointer;
}

.title:hover {
    opacity: 0.7;
}

.image:hover {
    opacity: 0.7;
}

.abc {
    width: 100%;
    height: 300px;
    position: relative;
}

h4 {
    display: block;
}

.image {
    background-size: cover;
    position: absolute;
    top: 0;
    background-color: grey;
    width: 100%;
    height: 100%;
}

.p {
    font-size: 14px;
}
</style>
